import optionImg from "@/assets/images/intro-image.jpg";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@/hooks/use-translation";

export default function IntroSection() {
   const navigate = useNavigate();
   const { translation, localizePath } = useTranslation();
   const { home } = translation;

   return (
      <div
         className="flex flex-col justify-end items-start min-h-screen bg-cover rotate-z-180 bg-center"
         style={{ backgroundImage: `url(${optionImg})` }}
      >
         {/* Intro content */}
         <div className="pl-10 pb-16 text-white">
            <h1 className="text-d-h1">{home.heading}</h1>
            <Button
               onClick={() => navigate(localizePath("/categories"))}
               className="mt-4"
               variant="l-dark"
            >
               {home.button}
            </Button>
         </div>
      </div>
   );
}
